import { VALIDATIONS_SET_DATA } from '../actions';

const INIT_STATE = {
    requiresSpouse: false,
    requiresSpouseCodebtor: false,
    createCodebtor: false,
    enableContactCodebtor: false,
    enableSpouseCodebtor: false,
    enableHeritageCodebtor: false,
    finishStepsCodebtor: false,
    returnToComponentCodebtor: false,
    editProcessWizard: false,
    refreshListCredit: false,
    loadingCalculator: false,
    errorCalculatorCredit: false,
    codebtorExist: false,
    informationCreditErrors: null,
    isLastStep: false,
    nextStepControl: false,
    inputsFinalRequest: {},
    codebtorValidation: { validation: true, numero_identificacion: null },
    seguroVidaValidation: false,
    documentosEmpleadoValidation: false,
    formHasChange: false,
    dinamixSeccion: false,
    showSupportIcon: true,
    nextButtonClicked: false,
    validationFields: true,
    inputsFinalRequestWarrantyVehicle: {},
    contacsWarranty: false,
    showMonitoring: false,

};

const validationsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case VALIDATIONS_SET_DATA:
            return { ...state, ...action.payload };
        default:
            return { ...state };
    }
};

export default validationsReducer;
